import { AfterContentChecked, ChangeDetectorRef, Component, HostListener } from '@angular/core';
import { UtilsService } from './shared/services/utils.service';
import { environment } from "../environments/environment";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements AfterContentChecked{
  title = 'liberty-Front';  
  message:any = [];

  ngAfterContentChecked(){this.cd.detectChanges()}
  constructor(public utilsService: UtilsService,public cd : ChangeDetectorRef) {}
  
  ngOnInit(): void {
    this.requestPermission();
    this.listen();
  }

  requestPermission() {
    const messaging = getMessaging();
    getToken(messaging, 
     { vapidKey: environment.firebase.vapidKey}).then(
       (currentToken) => {
         if (currentToken) {
           console.log("Hurraaa!!! we got the token.....");
           this.utilsService.notificationToken = currentToken;
           sessionStorage.setItem('NotificationToken',currentToken);
          //  console.log(this.utilsService.notificationToken);
         } else {
           console.log('No registration token available. Request permission to generate one.');
         }
     }).catch((err) => {
        console.log('An error occurred while retrieving token. ', err);
    });
  }
  listen() {
    const messaging = getMessaging();
    onMessage(messaging, (payload) => {
      console.log('Message received. ', payload);
      this.message.push(payload);
      this.utilsService.countOfNotification += 1;
      setTimeout(() => {
        if (this.message.length > 0) {
          this.message.shift(); // Remove the first element
        }
      }, 10000);
    });
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event: Event): void {
    // this.utilsService.logout();
  }

  
}
